/** Font Awesome 6.7.2 Free solid icon names (kebab-case). Auto-generated. */
export const FA_SOLID_ICON_NAMES: { [name: string]: true } = {
  '0': true,
  '1': true,
  '2': true,
  '3': true,
  '4': true,
  '5': true,
  '6': true,
  '7': true,
  '8': true,
  '9': true,
  'a': true,
  'address-book': true,
  'address-card': true,
  'align-center': true,
  'align-justify': true,
  'align-left': true,
  'align-right': true,
  'anchor': true,
  'anchor-circle-check': true,
  'anchor-circle-exclamation': true,
  'anchor-circle-xmark': true,
  'anchor-lock': true,
  'angle-down': true,
  'angle-left': true,
  'angle-right': true,
  'angle-up': true,
  'angles-down': true,
  'angles-left': true,
  'angles-right': true,
  'angles-up': true,
  'ankh': true,
  'apple-whole': true,
  'archway': true,
  'arrow-down': true,
  'arrow-down-1-9': true,
  'arrow-down-9-1': true,
  'arrow-down-a-z': true,
  'arrow-down-long': true,
  'arrow-down-short-wide': true,
  'arrow-down-up-across-line': true,
  'arrow-down-up-lock': true,
  'arrow-down-wide-short': true,
  'arrow-down-z-a': true,
  'arrow-left': true,
  'arrow-left-long': true,
  'arrow-pointer': true,
  'arrow-right': true,
  'arrow-right-arrow-left': true,
  'arrow-right-from-bracket': true,
  'arrow-right-long': true,
  'arrow-right-to-bracket': true,
  'arrow-right-to-city': true,
  'arrow-rotate-left': true,
  'arrow-rotate-right': true,
  'arrow-trend-down': true,
  'arrow-trend-up': true,
  'arrow-turn-down': true,
  'arrow-turn-up': true,
  'arrow-up': true,
  'arrow-up-1-9': true,
  'arrow-up-9-1': true,
  'arrow-up-a-z': true,
  'arrow-up-from-bracket': true,
  'arrow-up-from-ground-water': true,
  'arrow-up-from-water-pump': true,
  'arrow-up-long': true,
  'arrow-up-right-dots': true,
  'arrow-up-right-from-square': true,
  'arrow-up-short-wide': true,
  'arrow-up-wide-short': true,
  'arrow-up-z-a': true,
  'arrows-down-to-line': true,
  'arrows-down-to-people': true,
  'arrows-left-right': true,
  'arrows-left-right-to-line': true,
  'arrows-rotate': true,
  'arrows-spin': true,
  'arrows-split-up-and-left': true,
  'arrows-to-circle': true,
  'arrows-to-dot': true,
  'arrows-to-eye': true,
  'arrows-turn-right': true,
  'arrows-turn-to-dots': true,
  'arrows-up-down': true,
  'arrows-up-down-left-right': true,
  'arrows-up-to-line': true,
  'asterisk': true,
  'at': true,
  'atom': true,
  'audio-description': true,
  'austral-sign': true,
  'award': true,
  'b': true,
  'baby': true,
  'baby-carriage': true,
  'backward': true,
  'backward-fast': true,
  'backward-step': true,
  'bacon': true,
  'bacteria': true,
  'bacterium': true,
  'bag-shopping': true,
  'bahai': true,
  'baht-sign': true,
  'ban': true,
  'ban-smoking': true,
  'bandage': true,
  'bangladeshi-taka-sign': true,
  'barcode': true,
  'bars': true,
  'bars-progress': true,
  'bars-staggered': true,
  'baseball': true,
  'baseball-bat-ball': true,
  'basket-shopping': true,
  'basketball': true,
  'bath': true,
  'battery-empty': true,
  'battery-full': true,
  'battery-half': true,
  'battery-quarter': true,
  'battery-three-quarters': true,
  'bed': true,
  'bed-pulse': true,
  'beer-mug-empty': true,
  'bell': true,
  'bell-concierge': true,
  'bell-slash': true,
  'bezier-curve': true,
  'bicycle': true,
  'binoculars': true,
  'biohazard': true,
  'bitcoin-sign': true,
  'blender': true,
  'blender-phone': true,
  'blog': true,
  'bold': true,
  'bolt': true,
  'bolt-lightning': true,
  'bomb': true,
  'bone': true,
  'bong': true,
  'book': true,
  'book-atlas': true,
  'book-bible': true,
  'book-bookmark': true,
  'book-journal-whills': true,
  'book-medical': true,
  'book-open': true,
  'book-open-reader': true,
  'book-quran': true,
  'book-skull': true,
  'book-tanakh': true,
  'bookmark': true,
  'border-all': true,
  'border-none': true,
  'border-top-left': true,
  'bore-hole': true,
  'bottle-droplet': true,
  'bottle-water': true,
  'bowl-food': true,
  'bowl-rice': true,
  'bowling-ball': true,
  'box': true,
  'box-archive': true,
  'box-open': true,
  'box-tissue': true,
  'boxes-packing': true,
  'boxes-stacked': true,
  'braille': true,
  'brain': true,
  'brazilian-real-sign': true,
  'bread-slice': true,
  'bridge': true,
  'bridge-circle-check': true,
  'bridge-circle-exclamation': true,
  'bridge-circle-xmark': true,
  'bridge-lock': true,
  'bridge-water': true,
  'briefcase': true,
  'briefcase-medical': true,
  'broom': true,
  'broom-ball': true,
  'brush': true,
  'bucket': true,
  'bug': true,
  'bug-slash': true,
  'bugs': true,
  'building': true,
  'building-circle-arrow-right': true,
  'building-circle-check': true,
  'building-circle-exclamation': true,
  'building-circle-xmark': true,
  'building-columns': true,
  'building-flag': true,
  'building-lock': true,
  'building-ngo': true,
  'building-shield': true,
  'building-un': true,
  'building-user': true,
  'building-wheat': true,
  'bullhorn': true,
  'bullseye': true,
  'burger': true,
  'burst': true,
  'bus': true,
  'bus-simple': true,
  'business-time': true,
  'c': true,
  'cable-car': true,
  'cake-candles': true,
  'calculator': true,
  'calendar': true,
  'calendar-check': true,
  'calendar-day': true,
  'calendar-days': true,
  'calendar-minus': true,
  'calendar-plus': true,
  'calendar-week': true,
  'calendar-xmark': true,
  'camera': true,
  'camera-retro': true,
  'camera-rotate': true,
  'campground': true,
  'candy-cane': true,
  'cannabis': true,
  'capsules': true,
  'car': true,
  'car-battery': true,
  'car-burst': true,
  'car-on': true,
  'car-rear': true,
  'car-side': true,
  'car-tunnel': true,
  'caravan': true,
  'caret-down': true,
  'caret-left': true,
  'caret-right': true,
  'caret-up': true,
  'carrot': true,
  'cart-arrow-down': true,
  'cart-flatbed': true,
  'cart-flatbed-suitcase': true,
  'cart-plus': true,
  'cart-shopping': true,
  'cash-register': true,
  'cat': true,
  'cedi-sign': true,
  'cent-sign': true,
  'certificate': true,
  'chair': true,
  'chalkboard': true,
  'chalkboard-user': true,
  'champagne-glasses': true,
  'charging-station': true,
  'chart-area': true,
  'chart-bar': true,
  'chart-column': true,
  'chart-diagram': true,
  'chart-gantt': true,
  'chart-line': true,
  'chart-pie': true,
  'chart-simple': true,
  'check': true,
  'check-double': true,
  'check-to-slot': true,
  'cheese': true,
  'chess': true,
  'chess-bishop': true,
  'chess-board': true,
  'chess-king': true,
  'chess-knight': true,
  'chess-pawn': true,
  'chess-queen': true,
  'chess-rook': true,
  'chevron-down': true,
  'chevron-left': true,
  'chevron-right': true,
  'chevron-up': true,
  'child': true,
  'child-combatant': true,
  'child-dress': true,
  'child-reaching': true,
  'children': true,
  'church': true,
  'circle': true,
  'circle-arrow-down': true,
  'circle-arrow-left': true,
  'circle-arrow-right': true,
  'circle-arrow-up': true,
  'circle-check': true,
  'circle-chevron-down': true,
  'circle-chevron-left': true,
  'circle-chevron-right': true,
  'circle-chevron-up': true,
  'circle-dollar-to-slot': true,
  'circle-dot': true,
  'circle-down': true,
  'circle-exclamation': true,
  'circle-h': true,
  'circle-half-stroke': true,
  'circle-info': true,
  'circle-left': true,
  'circle-minus': true,
  'circle-nodes': true,
  'circle-notch': true,
  'circle-pause': true,
  'circle-play': true,
  'circle-plus': true,
  'circle-question': true,
  'circle-radiation': true,
  'circle-right': true,
  'circle-stop': true,
  'circle-up': true,
  'circle-user': true,
  'circle-xmark': true,
  'city': true,
  'clapperboard': true,
  'clipboard': true,
  'clipboard-check': true,
  'clipboard-list': true,
  'clipboard-question': true,
  'clipboard-user': true,
  'clock': true,
  'clock-rotate-left': true,
  'clone': true,
  'closed-captioning': true,
  'cloud': true,
  'cloud-arrow-down': true,
  'cloud-arrow-up': true,
  'cloud-bolt': true,
  'cloud-meatball': true,
  'cloud-moon': true,
  'cloud-moon-rain': true,
  'cloud-rain': true,
  'cloud-showers-heavy': true,
  'cloud-showers-water': true,
  'cloud-sun': true,
  'cloud-sun-rain': true,
  'clover': true,
  'code': true,
  'code-branch': true,
  'code-commit': true,
  'code-compare': true,
  'code-fork': true,
  'code-merge': true,
  'code-pull-request': true,
  'coins': true,
  'colon-sign': true,
  'comment': true,
  'comment-dollar': true,
  'comment-dots': true,
  'comment-medical': true,
  'comment-nodes': true,
  'comment-slash': true,
  'comment-sms': true,
  'comments': true,
  'comments-dollar': true,
  'compact-disc': true,
  'compass': true,
  'compass-drafting': true,
  'compress': true,
  'computer': true,
  'computer-mouse': true,
  'cookie': true,
  'cookie-bite': true,
  'copy': true,
  'copyright': true,
  'couch': true,
  'cow': true,
  'credit-card': true,
  'crop': true,
  'crop-simple': true,
  'cross': true,
  'crosshairs': true,
  'crow': true,
  'crown': true,
  'crutch': true,
  'cruzeiro-sign': true,
  'cube': true,
  'cubes': true,
  'cubes-stacked': true,
  'd': true,
  'database': true,
  'delete-left': true,
  'democrat': true,
  'desktop': true,
  'dharmachakra': true,
  'diagram-next': true,
  'diagram-predecessor': true,
  'diagram-project': true,
  'diagram-successor': true,
  'diamond': true,
  'diamond-turn-right': true,
  'dice': true,
  'dice-d20': true,
  'dice-d6': true,
  'dice-five': true,
  'dice-four': true,
  'dice-one': true,
  'dice-six': true,
  'dice-three': true,
  'dice-two': true,
  'disease': true,
  'display': true,
  'divide': true,
  'dna': true,
  'dog': true,
  'dollar-sign': true,
  'dolly': true,
  'dong-sign': true,
  'door-closed': true,
  'door-open': true,
  'dove': true,
  'down-left-and-up-right-to-center': true,
  'down-long': true,
  'download': true,
  'dragon': true,
  'draw-polygon': true,
  'droplet': true,
  'droplet-slash': true,
  'drum': true,
  'drum-steelpan': true,
  'drumstick-bite': true,
  'dumbbell': true,
  'dumpster': true,
  'dumpster-fire': true,
  'dungeon': true,
  'e': true,
  'ear-deaf': true,
  'ear-listen': true,
  'earth-africa': true,
  'earth-americas': true,
  'earth-asia': true,
  'earth-europe': true,
  'earth-oceania': true,
  'egg': true,
  'eject': true,
  'elevator': true,
  'ellipsis': true,
  'ellipsis-vertical': true,
  'envelope': true,
  'envelope-circle-check': true,
  'envelope-open': true,
  'envelope-open-text': true,
  'envelopes-bulk': true,
  'equals': true,
  'eraser': true,
  'ethernet': true,
  'euro-sign': true,
  'exclamation': true,
  'expand': true,
  'explosion': true,
  'eye': true,
  'eye-dropper': true,
  'eye-low-vision': true,
  'eye-slash': true,
  'f': true,
  'face-angry': true,
  'face-dizzy': true,
  'face-flushed': true,
  'face-frown': true,
  'face-frown-open': true,
  'face-grimace': true,
  'face-grin': true,
  'face-grin-beam': true,
  'face-grin-beam-sweat': true,
  'face-grin-hearts': true,
  'face-grin-squint': true,
  'face-grin-squint-tears': true,
  'face-grin-stars': true,
  'face-grin-tears': true,
  'face-grin-tongue': true,
  'face-grin-tongue-squint': true,
  'face-grin-tongue-wink': true,
  'face-grin-wide': true,
  'face-grin-wink': true,
  'face-kiss': true,
  'face-kiss-beam': true,
  'face-kiss-wink-heart': true,
  'face-laugh': true,
  'face-laugh-beam': true,
  'face-laugh-squint': true,
  'face-laugh-wink': true,
  'face-meh': true,
  'face-meh-blank': true,
  'face-rolling-eyes': true,
  'face-sad-cry': true,
  'face-sad-tear': true,
  'face-smile': true,
  'face-smile-beam': true,
  'face-smile-wink': true,
  'face-surprise': true,
  'face-tired': true,
  'fan': true,
  'faucet': true,
  'faucet-drip': true,
  'fax': true,
  'feather': true,
  'feather-pointed': true,
  'ferry': true,
  'file': true,
  'file-arrow-down': true,
  'file-arrow-up': true,
  'file-audio': true,
  'file-circle-check': true,
  'file-circle-exclamation': true,
  'file-circle-minus': true,
  'file-circle-plus': true,
  'file-circle-question': true,
  'file-circle-xmark': true,
  'file-code': true,
  'file-contract': true,
  'file-csv': true,
  'file-excel': true,
  'file-export': true,
  'file-fragment': true,
  'file-half-dashed': true,
  'file-image': true,
  'file-import': true,
  'file-invoice': true,
  'file-invoice-dollar': true,
  'file-lines': true,
  'file-medical': true,
  'file-pdf': true,
  'file-pen': true,
  'file-powerpoint': true,
  'file-prescription': true,
  'file-shield': true,
  'file-signature': true,
  'file-video': true,
  'file-waveform': true,
  'file-word': true,
  'file-zipper': true,
  'fill': true,
  'fill-drip': true,
  'film': true,
  'filter': true,
  'filter-circle-dollar': true,
  'filter-circle-xmark': true,
  'fingerprint': true,
  'fire': true,
  'fire-burner': true,
  'fire-extinguisher': true,
  'fire-flame-curved': true,
  'fire-flame-simple': true,
  'fish': true,
  'fish-fins': true,
  'flag': true,
  'flag-checkered': true,
  'flag-usa': true,
  'flask': true,
  'flask-vial': true,
  'floppy-disk': true,
  'florin-sign': true,
  'folder': true,
  'folder-closed': true,
  'folder-minus': true,
  'folder-open': true,
  'folder-plus': true,
  'folder-tree': true,
  'font': true,
  'font-awesome': true,
  'football': true,
  'forward': true,
  'forward-fast': true,
  'forward-step': true,
  'franc-sign': true,
  'frog': true,
  'futbol': true,
  'g': true,
  'gamepad': true,
  'gas-pump': true,
  'gauge': true,
  'gauge-high': true,
  'gauge-simple': true,
  'gauge-simple-high': true,
  'gavel': true,
  'gear': true,
  'gears': true,
  'gem': true,
  'genderless': true,
  'ghost': true,
  'gift': true,
  'gifts': true,
  'glass-water': true,
  'glass-water-droplet': true,
  'glasses': true,
  'globe': true,
  'golf-ball-tee': true,
  'gopuram': true,
  'graduation-cap': true,
  'greater-than': true,
  'greater-than-equal': true,
  'grip': true,
  'grip-lines': true,
  'grip-lines-vertical': true,
  'grip-vertical': true,
  'group-arrows-rotate': true,
  'guarani-sign': true,
  'guitar': true,
  'gun': true,
  'h': true,
  'hammer': true,
  'hamsa': true,
  'hand': true,
  'hand-back-fist': true,
  'hand-dots': true,
  'hand-fist': true,
  'hand-holding': true,
  'hand-holding-dollar': true,
  'hand-holding-droplet': true,
  'hand-holding-hand': true,
  'hand-holding-heart': true,
  'hand-holding-medical': true,
  'hand-lizard': true,
  'hand-middle-finger': true,
  'hand-peace': true,
  'hand-point-down': true,
  'hand-point-left': true,
  'hand-point-right': true,
  'hand-point-up': true,
  'hand-pointer': true,
  'hand-scissors': true,
  'hand-sparkles': true,
  'hand-spock': true,
  'handcuffs': true,
  'hands': true,
  'hands-asl-interpreting': true,
  'hands-bound': true,
  'hands-bubbles': true,
  'hands-clapping': true,
  'hands-holding': true,
  'hands-holding-child': true,
  'hands-holding-circle': true,
  'hands-praying': true,
  'handshake': true,
  'handshake-angle': true,
  'handshake-simple': true,
  'handshake-simple-slash': true,
  'handshake-slash': true,
  'hanukiah': true,
  'hard-drive': true,
  'hashtag': true,
  'hat-cowboy': true,
  'hat-cowboy-side': true,
  'hat-wizard': true,
  'head-side-cough': true,
  'head-side-cough-slash': true,
  'head-side-mask': true,
  'head-side-virus': true,
  'heading': true,
  'headphones': true,
  'headphones-simple': true,
  'headset': true,
  'heart': true,
  'heart-circle-bolt': true,
  'heart-circle-check': true,
  'heart-circle-exclamation': true,
  'heart-circle-minus': true,
  'heart-circle-plus': true,
  'heart-circle-xmark': true,
  'heart-crack': true,
  'heart-pulse': true,
  'helicopter': true,
  'helicopter-symbol': true,
  'helmet-safety': true,
  'helmet-un': true,
  'hexagon-nodes': true,
  'hexagon-nodes-bolt': true,
  'highlighter': true,
  'hill-avalanche': true,
  'hill-rockslide': true,
  'hippo': true,
  'hockey-puck': true,
  'holly-berry': true,
  'horse': true,
  'horse-head': true,
  'hospital': true,
  'hospital-user': true,
  'hot-tub-person': true,
  'hotdog': true,
  'hotel': true,
  'hourglass': true,
  'hourglass-end': true,
  'hourglass-half': true,
  'hourglass-start': true,
  'house': true,
  'house-chimney': true,
  'house-chimney-crack': true,
  'house-chimney-medical': true,
  'house-chimney-user': true,
  'house-chimney-window': true,
  'house-circle-check': true,
  'house-circle-exclamation': true,
  'house-circle-xmark': true,
  'house-crack': true,
  'house-fire': true,
  'house-flag': true,
  'house-flood-water': true,
  'house-flood-water-circle-arrow-right': true,
  'house-laptop': true,
  'house-lock': true,
  'house-medical': true,
  'house-medical-circle-check': true,
  'house-medical-circle-exclamation': true,
  'house-medical-circle-xmark': true,
  'house-medical-flag': true,
  'house-signal': true,
  'house-tsunami': true,
  'house-user': true,
  'hryvnia-sign': true,
  'hurricane': true,
  'i': true,
  'i-cursor': true,
  'ice-cream': true,
  'icicles': true,
  'icons': true,
  'id-badge': true,
  'id-card': true,
  'id-card-clip': true,
  'igloo': true,
  'image': true,
  'image-portrait': true,
  'images': true,
  'inbox': true,
  'indent': true,
  'indian-rupee-sign': true,
  'industry': true,
  'infinity': true,
  'info': true,
  'italic': true,
  'j': true,
  'jar': true,
  'jar-wheat': true,
  'jedi': true,
  'jet-fighter': true,
  'jet-fighter-up': true,
  'joint': true,
  'jug-detergent': true,
  'k': true,
  'kaaba': true,
  'key': true,
  'keyboard': true,
  'khanda': true,
  'kip-sign': true,
  'kit-medical': true,
  'kitchen-set': true,
  'kiwi-bird': true,
  'l': true,
  'land-mine-on': true,
  'landmark': true,
  'landmark-dome': true,
  'landmark-flag': true,
  'language': true,
  'laptop': true,
  'laptop-code': true,
  'laptop-file': true,
  'laptop-medical': true,
  'lari-sign': true,
  'layer-group': true,
  'leaf': true,
  'left-long': true,
  'left-right': true,
  'lemon': true,
  'less-than': true,
  'less-than-equal': true,
  'life-ring': true,
  'lightbulb': true,
  'lines-leaning': true,
  'link': true,
  'link-slash': true,
  'lira-sign': true,
  'list': true,
  'list-check': true,
  'list-ol': true,
  'list-ul': true,
  'litecoin-sign': true,
  'location-arrow': true,
  'location-crosshairs': true,
  'location-dot': true,
  'location-pin': true,
  'location-pin-lock': true,
  'lock': true,
  'lock-open': true,
  'locust': true,
  'lungs': true,
  'lungs-virus': true,
  'm': true,
  'magnet': true,
  'magnifying-glass': true,
  'magnifying-glass-arrow-right': true,
  'magnifying-glass-chart': true,
  'magnifying-glass-dollar': true,
  'magnifying-glass-location': true,
  'magnifying-glass-minus': true,
  'magnifying-glass-plus': true,
  'manat-sign': true,
  'map': true,
  'map-location': true,
  'map-location-dot': true,
  'map-pin': true,
  'marker': true,
  'mars': true,
  'mars-and-venus': true,
  'mars-and-venus-burst': true,
  'mars-double': true,
  'mars-stroke': true,
  'mars-stroke-right': true,
  'mars-stroke-up': true,
  'martini-glass': true,
  'martini-glass-citrus': true,
  'martini-glass-empty': true,
  'mask': true,
  'mask-face': true,
  'mask-ventilator': true,
  'masks-theater': true,
  'mattress-pillow': true,
  'maximize': true,
  'medal': true,
  'memory': true,
  'menorah': true,
  'mercury': true,
  'message': true,
  'meteor': true,
  'microchip': true,
  'microphone': true,
  'microphone-lines': true,
  'microphone-lines-slash': true,
  'microphone-slash': true,
  'microscope': true,
  'mill-sign': true,
  'minimize': true,
  'minus': true,
  'mitten': true,
  'mobile': true,
  'mobile-button': true,
  'mobile-retro': true,
  'mobile-screen': true,
  'mobile-screen-button': true,
  'money-bill': true,
  'money-bill-1': true,
  'money-bill-1-wave': true,
  'money-bill-transfer': true,
  'money-bill-trend-up': true,
  'money-bill-wave': true,
  'money-bill-wheat': true,
  'money-bills': true,
  'money-check': true,
  'money-check-dollar': true,
  'monument': true,
  'moon': true,
  'mortar-pestle': true,
  'mosque': true,
  'mosquito': true,
  'mosquito-net': true,
  'motorcycle': true,
  'mound': true,
  'mountain': true,
  'mountain-city': true,
  'mountain-sun': true,
  'mug-hot': true,
  'mug-saucer': true,
  'music': true,
  'n': true,
  'naira-sign': true,
  'network-wired': true,
  'neuter': true,
  'newspaper': true,
  'not-equal': true,
  'notdef': true,
  'note-sticky': true,
  'notes-medical': true,
  'o': true,
  'object-group': true,
  'object-ungroup': true,
  'oil-can': true,
  'oil-well': true,
  'om': true,
  'otter': true,
  'outdent': true,
  'p': true,
  'pager': true,
  'paint-roller': true,
  'paintbrush': true,
  'palette': true,
  'pallet': true,
  'panorama': true,
  'paper-plane': true,
  'paperclip': true,
  'parachute-box': true,
  'paragraph': true,
  'passport': true,
  'paste': true,
  'pause': true,
  'paw': true,
  'peace': true,
  'pen': true,
  'pen-clip': true,
  'pen-fancy': true,
  'pen-nib': true,
  'pen-ruler': true,
  'pen-to-square': true,
  'pencil': true,
  'people-arrows': true,
  'people-carry-box': true,
  'people-group': true,
  'people-line': true,
  'people-pulling': true,
  'people-robbery': true,
  'people-roof': true,
  'pepper-hot': true,
  'percent': true,
  'person': true,
  'person-arrow-down-to-line': true,
  'person-arrow-up-from-line': true,
  'person-biking': true,
  'person-booth': true,
  'person-breastfeeding': true,
  'person-burst': true,
  'person-cane': true,
  'person-chalkboard': true,
  'person-circle-check': true,
  'person-circle-exclamation': true,
  'person-circle-minus': true,
  'person-circle-plus': true,
  'person-circle-question': true,
  'person-circle-xmark': true,
  'person-digging': true,
  'person-dots-from-line': true,
  'person-dress': true,
  'person-dress-burst': true,
  'person-drowning': true,
  'person-falling': true,
  'person-falling-burst': true,
  'person-half-dress': true,
  'person-harassing': true,
  'person-hiking': true,
  'person-military-pointing': true,
  'person-military-rifle': true,
  'person-military-to-person': true,
  'person-praying': true,
  'person-pregnant': true,
  'person-rays': true,
  'person-rifle': true,
  'person-running': true,
  'person-shelter': true,
  'person-skating': true,
  'person-skiing': true,
  'person-skiing-nordic': true,
  'person-snowboarding': true,
  'person-swimming': true,
  'person-through-window': true,
  'person-walking': true,
  'person-walking-arrow-loop-left': true,
  'person-walking-arrow-right': true,
  'person-walking-dashed-line-arrow-right': true,
  'person-walking-luggage': true,
  'person-walking-with-cane': true,
  'peseta-sign': true,
  'peso-sign': true,
  'phone': true,
  'phone-flip': true,
  'phone-slash': true,
  'phone-volume': true,
  'photo-film': true,
  'piggy-bank': true,
  'pills': true,
  'pizza-slice': true,
  'place-of-worship': true,
  'plane': true,
  'plane-arrival': true,
  'plane-circle-check': true,
  'plane-circle-exclamation': true,
  'plane-circle-xmark': true,
  'plane-departure': true,
  'plane-lock': true,
  'plane-slash': true,
  'plane-up': true,
  'plant-wilt': true,
  'plate-wheat': true,
  'play': true,
  'plug': true,
  'plug-circle-bolt': true,
  'plug-circle-check': true,
  'plug-circle-exclamation': true,
  'plug-circle-minus': true,
  'plug-circle-plus': true,
  'plug-circle-xmark': true,
  'plus': true,
  'plus-minus': true,
  'podcast': true,
  'poo': true,
  'poo-storm': true,
  'poop': true,
  'power-off': true,
  'prescription': true,
  'prescription-bottle': true,
  'prescription-bottle-medical': true,
  'print': true,
  'pump-medical': true,
  'pump-soap': true,
  'puzzle-piece': true,
  'q': true,
  'qrcode': true,
  'question': true,
  'quote-left': true,
  'quote-right': true,
  'r': true,
  'radiation': true,
  'radio': true,
  'rainbow': true,
  'ranking-star': true,
  'receipt': true,
  'record-vinyl': true,
  'rectangle-ad': true,
  'rectangle-list': true,
  'rectangle-xmark': true,
  'recycle': true,
  'registered': true,
  'repeat': true,
  'reply': true,
  'reply-all': true,
  'republican': true,
  'restroom': true,
  'retweet': true,
  'ribbon': true,
  'right-from-bracket': true,
  'right-left': true,
  'right-long': true,
  'right-to-bracket': true,
  'ring': true,
  'road': true,
  'road-barrier': true,
  'road-bridge': true,
  'road-circle-check': true,
  'road-circle-exclamation': true,
  'road-circle-xmark': true,
  'road-lock': true,
  'road-spikes': true,
  'robot': true,
  'rocket': true,
  'rotate': true,
  'rotate-left': true,
  'rotate-right': true,
  'route': true,
  'rss': true,
  'ruble-sign': true,
  'rug': true,
  'ruler': true,
  'ruler-combined': true,
  'ruler-horizontal': true,
  'ruler-vertical': true,
  'rupee-sign': true,
  'rupiah-sign': true,
  's': true,
  'sack-dollar': true,
  'sack-xmark': true,
  'sailboat': true,
  'satellite': true,
  'satellite-dish': true,
  'scale-balanced': true,
  'scale-unbalanced': true,
  'scale-unbalanced-flip': true,
  'school': true,
  'school-circle-check': true,
  'school-circle-exclamation': true,
  'school-circle-xmark': true,
  'school-flag': true,
  'school-lock': true,
  'scissors': true,
  'screwdriver': true,
  'screwdriver-wrench': true,
  'scroll': true,
  'scroll-torah': true,
  'sd-card': true,
  'section': true,
  'seedling': true,
  'server': true,
  'shapes': true,
  'share': true,
  'share-from-square': true,
  'share-nodes': true,
  'sheet-plastic': true,
  'shekel-sign': true,
  'shield': true,
  'shield-cat': true,
  'shield-dog': true,
  'shield-halved': true,
  'shield-heart': true,
  'shield-virus': true,
  'ship': true,
  'shirt': true,
  'shoe-prints': true,
  'shop': true,
  'shop-lock': true,
  'shop-slash': true,
  'shower': true,
  'shrimp': true,
  'shuffle': true,
  'shuttle-space': true,
  'sign-hanging': true,
  'signal': true,
  'signature': true,
  'signs-post': true,
  'sim-card': true,
  'sink': true,
  'sitemap': true,
  'skull': true,
  'skull-crossbones': true,
  'slash': true,
  'sleigh': true,
  'sliders': true,
  'smog': true,
  'smoking': true,
  'snowflake': true,
  'snowman': true,
  'snowplow': true,
  'soap': true,
  'socks': true,
  'solar-panel': true,
  'sort': true,
  'sort-down': true,
  'sort-up': true,
  'spa': true,
  'spaghetti-monster-flying': true,
  'spell-check': true,
  'spider': true,
  'spinner': true,
  'splotch': true,
  'spoon': true,
  'spray-can': true,
  'spray-can-sparkles': true,
  'square': true,
  'square-arrow-up-right': true,
  'square-binary': true,
  'square-caret-down': true,
  'square-caret-left': true,
  'square-caret-right': true,
  'square-caret-up': true,
  'square-check': true,
  'square-envelope': true,
  'square-full': true,
  'square-h': true,
  'square-minus': true,
  'square-nfi': true,
  'square-parking': true,
  'square-pen': true,
  'square-person-confined': true,
  'square-phone': true,
  'square-phone-flip': true,
  'square-plus': true,
  'square-poll-horizontal': true,
  'square-poll-vertical': true,
  'square-root-variable': true,
  'square-rss': true,
  'square-share-nodes': true,
  'square-up-right': true,
  'square-virus': true,
  'square-xmark': true,
  'staff-snake': true,
  'stairs': true,
  'stamp': true,
  'stapler': true,
  'star': true,
  'star-and-crescent': true,
  'star-half': true,
  'star-half-stroke': true,
  'star-of-david': true,
  'star-of-life': true,
  'sterling-sign': true,
  'stethoscope': true,
  'stop': true,
  'stopwatch': true,
  'stopwatch-20': true,
  'store': true,
  'store-slash': true,
  'street-view': true,
  'strikethrough': true,
  'stroopwafel': true,
  'subscript': true,
  'suitcase': true,
  'suitcase-medical': true,
  'suitcase-rolling': true,
  'sun': true,
  'sun-plant-wilt': true,
  'superscript': true,
  'swatchbook': true,
  'synagogue': true,
  'syringe': true,
  't': true,
  'table': true,
  'table-cells': true,
  'table-cells-column-lock': true,
  'table-cells-large': true,
  'table-cells-row-lock': true,
  'table-cells-row-unlock': true,
  'table-columns': true,
  'table-list': true,
  'table-tennis-paddle-ball': true,
  'tablet': true,
  'tablet-button': true,
  'tablet-screen-button': true,
  'tablets': true,
  'tachograph-digital': true,
  'tag': true,
  'tags': true,
  'tape': true,
  'tarp': true,
  'tarp-droplet': true,
  'taxi': true,
  'teeth': true,
  'teeth-open': true,
  'temperature-arrow-down': true,
  'temperature-arrow-up': true,
  'temperature-empty': true,
  'temperature-full': true,
  'temperature-half': true,
  'temperature-high': true,
  'temperature-low': true,
  'temperature-quarter': true,
  'temperature-three-quarters': true,
  'tenge-sign': true,
  'tent': true,
  'tent-arrow-down-to-line': true,
  'tent-arrow-left-right': true,
  'tent-arrow-turn-left': true,
  'tent-arrows-down': true,
  'tents': true,
  'terminal': true,
  'text-height': true,
  'text-slash': true,
  'text-width': true,
  'thermometer': true,
  'thumbs-down': true,
  'thumbs-up': true,
  'thumbtack': true,
  'thumbtack-slash': true,
  'ticket': true,
  'ticket-simple': true,
  'timeline': true,
  'toggle-off': true,
  'toggle-on': true,
  'toilet': true,
  'toilet-paper': true,
  'toilet-paper-slash': true,
  'toilet-portable': true,
  'toilets-portable': true,
  'toolbox': true,
  'tooth': true,
  'torii-gate': true,
  'tornado': true,
  'tower-broadcast': true,
  'tower-cell': true,
  'tower-observation': true,
  'tractor': true,
  'trademark': true,
  'traffic-light': true,
  'trailer': true,
  'train': true,
  'train-subway': true,
  'train-tram': true,
  'transgender': true,
  'trash': true,
  'trash-arrow-up': true,
  'trash-can': true,
  'trash-can-arrow-up': true,
  'tree': true,
  'tree-city': true,
  'triangle-exclamation': true,
  'trophy': true,
  'trowel': true,
  'trowel-bricks': true,
  'truck': true,
  'truck-arrow-right': true,
  'truck-droplet': true,
  'truck-fast': true,
  'truck-field': true,
  'truck-field-un': true,
  'truck-front': true,
  'truck-medical': true,
  'truck-monster': true,
  'truck-moving': true,
  'truck-pickup': true,
  'truck-plane': true,
  'truck-ramp-box': true,
  'tty': true,
  'turkish-lira-sign': true,
  'turn-down': true,
  'turn-up': true,
  'tv': true,
  'u': true,
  'umbrella': true,
  'umbrella-beach': true,
  'underline': true,
  'universal-access': true,
  'unlock': true,
  'unlock-keyhole': true,
  'up-down': true,
  'up-down-left-right': true,
  'up-long': true,
  'up-right-and-down-left-from-center': true,
  'up-right-from-square': true,
  'upload': true,
  'user': true,
  'user-astronaut': true,
  'user-check': true,
  'user-clock': true,
  'user-doctor': true,
  'user-gear': true,
  'user-graduate': true,
  'user-group': true,
  'user-injured': true,
  'user-large': true,
  'user-large-slash': true,
  'user-lock': true,
  'user-minus': true,
  'user-ninja': true,
  'user-nurse': true,
  'user-pen': true,
  'user-plus': true,
  'user-secret': true,
  'user-shield': true,
  'user-slash': true,
  'user-tag': true,
  'user-tie': true,
  'user-xmark': true,
  'users': true,
  'users-between-lines': true,
  'users-gear': true,
  'users-line': true,
  'users-rays': true,
  'users-rectangle': true,
  'users-slash': true,
  'users-viewfinder': true,
  'utensils': true,
  'v': true,
  'van-shuttle': true,
  'vault': true,
  'vector-square': true,
  'venus': true,
  'venus-double': true,
  'venus-mars': true,
  'vest': true,
  'vest-patches': true,
  'vial': true,
  'vial-circle-check': true,
  'vial-virus': true,
  'vials': true,
  'video': true,
  'video-slash': true,
  'vihara': true,
  'virus': true,
  'virus-covid': true,
  'virus-covid-slash': true,
  'virus-slash': true,
  'viruses': true,
  'voicemail': true,
  'volcano': true,
  'volleyball': true,
  'volume-high': true,
  'volume-low': true,
  'volume-off': true,
  'volume-xmark': true,
  'vr-cardboard': true,
  'w': true,
  'walkie-talkie': true,
  'wallet': true,
  'wand-magic': true,
  'wand-magic-sparkles': true,
  'wand-sparkles': true,
  'warehouse': true,
  'water': true,
  'water-ladder': true,
  'wave-square': true,
  'web-awesome': true,
  'weight-hanging': true,
  'weight-scale': true,
  'wheat-awn': true,
  'wheat-awn-circle-exclamation': true,
  'wheelchair': true,
  'wheelchair-move': true,
  'whiskey-glass': true,
  'wifi': true,
  'wind': true,
  'window-maximize': true,
  'window-minimize': true,
  'window-restore': true,
  'wine-bottle': true,
  'wine-glass': true,
  'wine-glass-empty': true,
  'won-sign': true,
  'worm': true,
  'wrench': true,
  'x': true,
  'x-ray': true,
  'xmark': true,
  'xmarks-lines': true,
  'y': true,
  'yen-sign': true,
  'yin-yang': true,
  'z': true
};
